<cb-dialog dialogHeading="Product Centre">
    <cb-product-centre-tab
        [isInDialog]="true"
        [initializeSearchOnLoad]="data.initializeSearchOnLoad"
        [lockedCategoryIdFilter]="data.categoryIdFilter"
        [businessEntityIdsToFilterBy]="data.businessEntityIdsToFilterBy"
        [businessEntityIdsToSortBy]="data.businessEntityIdsToSortBy"
        [restrictedBusinessEntityIds]="data.restrictedBusinessEntityIds"
        [hideNationalRate]="data.hideNationalRate"
        [existingSlotItem]="data.existingSlotItem"
        [showCurrentProduct]="data.showCurrentProduct"
        [currentProductTitle]="data.currentProductTitle"
        [ignoreTierBasedSorting]="data.ignoreTierBasedSorting"
        (selectedProduct)="productSelected($event)"
    >
    </cb-product-centre-tab>
    <div actions>
        <button mat-raised-button
                (click)="close()">Close</button>
    </div>
</cb-dialog>
